// Downscale an image in the browser before upload.
// Phone photos are 2-5MB; a snag photo needs none of that.
export async function downscale(file, maxEdge = 1600, quality = 0.82) {
  if (!file.type.startsWith('image/')) return file
  try {
    const bitmap = await createImageBitmap(file)
    const { width: w, height: h } = bitmap
    if (Math.max(w, h) <= maxEdge && file.size < 600 * 1024) return file
    const scale = Math.min(1, maxEdge / Math.max(w, h))
    const cw = Math.round(w * scale), ch = Math.round(h * scale)
    const canvas = document.createElement('canvas')
    canvas.width = cw; canvas.height = ch
    canvas.getContext('2d').drawImage(bitmap, 0, 0, cw, ch)
    bitmap.close?.()
    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', quality))
    if (!blob || blob.size >= file.size) return file
    return new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' })
  } catch {
    return file   // any failure: upload the original
  }
}
